"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_paper_1 = require("react-native-paper");
const modalStyles_1 = __importDefault(require("./modalStyles"));
const ModalBox = ({ children, fromBottom = false, showModal, dismissModal }) => {
    return (react_1.default.createElement(react_native_paper_1.Portal, null,
        react_1.default.createElement(react_native_paper_1.Modal, { visible: showModal, onDismiss: dismissModal, contentContainerStyle: [modalStyles_1.default.modalStyle, fromBottom ? modalStyles_1.default.modalPositionBottom : null] }, children)));
};
ModalBox.defaultProps = {
    fromBottom: false,
};
exports.default = ModalBox;
